// src/catalogos/estadosMunicipios.js

export const OFICINAS_POR_MUNICIPIO = {
  "Benito Juárez": [
    "Sindicato de Taxistas",
    "Dirección de Tránsito Xcaret",
    "Delegacion Imoveqroo Alcatraces",
    "Dirección de recaudación"
    
  ],

  "Solidaridad": [
    "Dirección de Tránsito Playa del Carmen",
    "Plaza Palmeras",
     "Dirección de recaudación",
    "Imoveqroo"
  ],

  "Tulum": [
    "IMOVEQROO Plaza Andadores",
     "Dirección de recaudación"
  ],

  "Cozumel": [
    "Dirección de Tránsito",
    "Dirección de recaudación"
  ],

  "Isla Mujeres": [
    "Peninsular Tránsito",
    "Insular Tránsito",
     "Dirección de recaudación"
  ],

  "Othon P. Blanco": [
    "Plaza Manatí",
    "OME SRE",
     "Dirección de recaudación",
     "Sindicato de Taxistas",
     "Modulo Ghandi"
  ],

  "Bacalar": [
    "Dirección de Tránsito",
     "Dirección de recaudación"
  ],

  "Jose María Morelos": [
    "Dirección de Tránsito",
     "Dirección de recaudación"
  ],

  "Lázaro Cárdenas": [
    "Dirección de Tránsito",
     "Dirección de recaudación"
  ],

  "Puerto Morelos": [
    "Dirección de Tránsito",
     "Dirección de recaudación"
  ],

  "Carrillo Puerto": [
    "Dirección de Tránsito",
     "Dirección de recaudación"
  ],

  "Unidades Móviles": [
    "Unidad Móvil 1",
    "Unidad Móvil 2"
  ]
};
